module.exports = __webpack_public_path__ + "assets/img/03.417ec7b9.png";